export default __webpack_public_path__ + "static/media/link.7c6c8c82.svg";